/**
 * Shared defaults for the homepage media floater carousel.
 */

export const MEDIA_FLOATER_DEFAULT_IMAGE_MS = 3000
export const MEDIA_FLOATER_DEFAULT_VIDEO_MS = 10000
export const MEDIA_FLOATER_MAX_RETRIES = 2

/** Fallback placeholder when image URL fails after retries */
export const MEDIA_FLOATER_FALLBACK_IMAGE =
    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="600" viewBox="0 0 400 600"%3E%3Crect fill="%23f3f4f6" width="400" height="600"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="18" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EImage not available%3C/text%3E%3C/svg%3E'
